import React, { useState, useEffect, useRef } from "react";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import debounce from "lodash.debounce";
import axios from "axios";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import GisApiServices from "../../services/GisApiServices";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
const layersData = [
    "Administrative Boundaries",
    "Agriculture",
    "Climate",
    "Cooperative Societies",
    "Cultural",
    "Education",
    "Election",
    "Emergency Services",
    "Excise",
];
const RouteTools = ({ view }) => {
    const dispatch = useDispatch()
    const [districts, setDistricts] = useState([]); // District list
    const [selectedDistrict, setSelectedDistrict] = useState(""); // Selected district name
    const [districtCode, setDistrictCode] = useState(""); // Selected district code
    const { isTheme } = useSelector((state) => state.currentStage)
    const [ulbs, setUlbs] = useState([]); // ULB list
    const [selectedUlb, setSelectedUlb] = useState(""); // Selected ULB name
    const [ulbCode, setUlbCode] = useState(""); // Selected ULB code

    const [wards, setWards] = useState([]); // Ward list
    const [selectedWard, setSelectedWard] = useState(""); // Selected ward name
    const [wardCode, setWardCode] = useState(""); // Selected ward code
    const [selectedSearch, setSelectedSearch] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [propertyInfo, setPropertyInfo] = useState([]);
    const [property, setProperty] = useState({});
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const searchOptions = ["E-NagarPalika ID", "Owner Name", "Mobile Number", "relation_id"];
    const authData = useSelector(state => state.authToken.authData);
    const { isDistCd, isUlbCd, isWardNo } = useSelector((state) => state.currentStage)
    const [activeSelect, setActiveSelect] = useState("area");
    console.log("authData121", authData)
    const [expanded, setExpanded] = useState({});
    const [checked, setChecked] = useState({});
    const [search, setSearch] = useState("");

    const toggleExpand = (layer) => {
        setExpanded((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const toggleCheck = (layer) => {
        setChecked((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const filteredLayers = layersData.filter((layer) =>
        layer.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        const loadDistricts = async () => {
            const url =
                "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";

            try {
                const response = await fetch(url);
                const data = await response.json();
                console.log("authData-by", authData);

                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const formattedDistricts = [{
                        districtName: authData?.DistrictName,
                        districtCode: authData?.DistrictCode,
                    }];
                    setDistricts(formattedDistricts);
                    setDistrictCode(authData?.DistrictCode);
                    setSelectedDistrict(authData?.DistrictName);
                    zoomToFeatureOne(authData?.DistrictName, "DistrictName", "3"); // 
                    await loadUlbs(authData?.DistrictCode)
                } else {
                    if (data.features) {
                        const formattedDistricts = data.features.map((f) => ({
                            districtName: f.properties.districtname,
                            districtCode: f.properties.dist_cd,
                        }));
                        setDistricts(formattedDistricts);
                    }
                }
            } catch (error) {
                console.log("Error fetching districts:", error);
            }
        };

        loadDistricts();
    }, [authData]);


    const handleDistrictChange = async (event) => {
        const selectedValue = event.target.value;
        console.log("selectedValueselectedValue", selectedValue)
        const selectedDistrictObj = districts.find(d => d.districtCode === selectedValue);
        dispatch(setIsDist(selectedValue))
        if (selectedDistrictObj) {
            setSelectedDistrict(selectedDistrictObj.districtName);
            setDistrictCode(selectedDistrictObj.districtCode);

            setUlbs([]);
            setUlbCode("");
            setSelectedUlb("");

            await loadUlbs(selectedDistrictObj.districtCode); // 

            zoomToFeatureOne(selectedDistrictObj.districtName, "DistrictName", "3"); // 
        } else {
            setSelectedDistrict("");
            setDistrictCode("");
            setUlbs([]);
            setUlbCode("");
            setSelectedUlb("");
        }
    };


    // ✅ Load ULBs using district code
    const loadUlbs = async (dist_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();

            if (authData?.UserType === "User") {
                const formattedUlbs = [{
                    ulbName: authData?.UlbName,
                    ulbCode: authData?.Ulb_Code,
                }];
                setUlbs(formattedUlbs);
                setUlbCode(authData?.Ulb_Code);
                setSelectedUlb(authData?.UlbName);
                zoomToFeatureTow(authData?.UlbName, "name", "5");
                await loadWards(authData?.Ulb_Code);
            } else if (data.features) {
                const formattedUlbs = data.features.map(f => ({
                    ulbName: f.properties.name,
                    ulbCode: f.properties.ulb_cd,
                }));
                setUlbs(formattedUlbs);
            }
        } catch (error) {
            console.error("Error fetching ULBs:", error);
        }
    };



    const handleUlbChange = async (event) => {
        const selectedValue = event.target.value;
        const selectedUlbObj = ulbs.find(ulb => ulb.ulbCode === selectedValue);
        dispatch(setIsUlb(selectedValue))
        if (selectedUlbObj) {
            setSelectedUlb(selectedUlbObj.ulbName);
            setUlbCode(selectedUlbObj.ulbCode);
            setWards([]);
            setWardCode("");
            setSelectedWard("");

            await loadWards(selectedUlbObj.ulbCode);
            zoomToFeatureTow(selectedUlbObj.ulbName, "name", "5");
        } else {
            setSelectedUlb("");
            setUlbCode("");
            setWards([]); // 
            setWardCode("");
            setSelectedWard("");
        }
    };



    const loadWards = async (ulb_cd) => {
        console.log("Fetching wards for ULB code:", ulb_cd);

        const wardLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7/query";
        const wardQuery = `where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

        try {
            const wardResponse = await fetch(`${wardLayerUrl}?${wardQuery}`);
            const wardData = await wardResponse.json();

            if (wardData.features) {
                const formattedWards = wardData.features.map((f) => ({
                    wardName: f.properties.wardname,
                    wardCode: f.properties.wardno
                }));

                setWards(formattedWards);
                setWardCode("");
                setSelectedWard("");
            }
        } catch (error) {
            console.log("Error fetching wards:", error);
        }
    };


    const handleWardChange = async (event) => {
        const selectedValue = event.target.value;
        console.log("select ward", selectedValue)
        const selectedWardObj = wards.find(ward => ward.wardCode === selectedValue);
        dispatch(setIsWard(selectedValue))
        console.log("hdhehdhh", ulbCode)

        if (selectedWardObj) {
            setSelectedWard(selectedWardObj.wardName);
            setWardCode(selectedWardObj.wardCode);
            await zoomToFeatureThree(selectedWardObj.wardName, "wardname", "7", ulbCode);

        } else {
            setSelectedWard(""); // 
            setWardCode("");
        }
    };



    const handleSearchChange = (event) => {
        setSelectedSearch(event.target.value);
        setSearchInput("");
    };



    // Handle input value change
    const handleInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const handleGetInfo = async () => {
        try {

            const info = {
                ulbCode: ulbCode,
                wardCode: wardCode,
                mobileno: selectedSearch === "Mobile Number" ? searchInput : "",
                ownername: selectedSearch === "Owner Name" ? searchInput : "",
                e_nagarpalikaid: selectedSearch === "E-NagarPalika ID" ? searchInput : "",
                relation_id: selectedSearch === "relation_id" ? searchInput : "",
            };


            if (info?.relation_id) {
                await getNewTableData(info);
                return;
            }

            if (!info.mobileno && !info.ownername && !info.e_nagarpalikaid) {
                console.log("No search criteria provided. API call skipped.");
                return;
            }

            if (selectedSearch === "E-NagarPalika ID") {
                await fetchPropertyData(info);
            }

            await fetchPropertyData(info)


        } catch (error) {
            console.log("Error in handleGetInfo:", error);
            setPropertyInfo([]);
        }
    };

    // const fetchPropertyData = async (info) => {
    //     try {
    //         const queryParams = [];

    //         if (info.ulbCode) queryParams.push(`ulb_cd%3D%27${info.ulbCode}%27`);
    //         if (info.wardCode) queryParams.push(`wardno%3D%27${info.wardCode}%27`);
    //         if (info.mobileno) queryParams.push(`mobileno%3D%27${info.mobileno}%27`);
    //         if (info.ownername) queryParams.push(`ownername%3D%27${info.ownername}%27`);
    //         if (info.e_nagarpalikaid) queryParams.push(`e_nagarpalikaid%3D%27${info.e_nagarpalikaid}%27`);

    //         const whereClause = queryParams.join("+and+");

    //         const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=${whereClause}&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=geojson`;

    //         const response = await fetch(url);
    //         const data = await response.json();

    //         console.log("response", data.features);

    //         if (data.features && data.features.length > 0) {
    //             const propertyData = data.features.map(feature => ({
    //                 relation_id: feature.properties.relation_id || "N/A",
    //                 ownername: feature.properties.ownername || "N/A",
    //                 pin: feature.properties.pin || "N/A",
    //                 mobileno: feature.properties.mobileno || "N/A",
    //                 nooffloor: feature.properties.nooffloor || "N/A",
    //                 property: feature.properties.property || "N/A",
    //                 Photo: feature.properties.photolink || "N/A",
    //                 e_nagarpalikaid: feature.properties.e_nagarpalikaid || "N/A"
    //             }));

    //             const uniquePropertyData = Array.from(
    //                 new Map(propertyData.map(item => [item.relation_id, item])).values()
    //             );

    //             console.log("propertyData", uniquePropertyData);

    //             let eNagarpalikaIdToUse = info.e_nagarpalikaid;
    //             if (!eNagarpalikaIdToUse) {
    //                 // Extract from the first property item (or decide based on your use case)
    //                 eNagarpalikaIdToUse = uniquePropertyData[0]?.e_nagarpalikaid;
    //             }

    //             if (eNagarpalikaIdToUse && eNagarpalikaIdToUse !== "N/A") {
    //                 const taxData = await fetchTaxData(eNagarpalikaIdToUse);
    //                 console.log("taxDatataxData", taxData);

    //                 const mergedData = uniquePropertyData.map(item => ({
    //                     ...item,
    //                     ...taxData // merge tax data if available
    //                 }));

    //                 setPropertyInfo(mergedData);
    //             } else {
    //                 setPropertyInfo(uniquePropertyData);
    //             }

    //             // Highlight features
    //             const relationIds = data.features.map(f => f.properties.relation_id).filter(Boolean);
    //             if (relationIds.length > 0) {
    //                 highlightFeatures(relationIds);
    //             }
    //         } else {
    //             setPropertyInfo([]);
    //         }
    //     } catch (error) {
    //         console.error("Error in fetchPropertyData:", error);
    //         setPropertyInfo([]);
    //     }
    // };

    const fetchPropertyData = async (info) => {
        try {
            const queryParams = [];

            if (info.ulbCode) queryParams.push(`ulb_cd%3D%27${info.ulbCode}%27`);
            if (info.wardCode) queryParams.push(`wardno%3D%27${info.wardCode}%27`);
            if (info.mobileno) queryParams.push(`mobileno%3D%27${info.mobileno}%27`);
            if (info.ownername) queryParams.push(`ownername%3D%27${info.ownername}%27`);
            if (info.e_nagarpalikaid) queryParams.push(`e_nagarpalikaid%3D%27${info.e_nagarpalikaid}%27`);

            const whereClause = queryParams.join("+and+");

            const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=${whereClause}&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=geojson`;

            const response = await fetch(url);
            const data = await response.json();

            console.log("response", data.features);

            if (data.features && data.features.length > 0) {
                const propertyData = data.features.map(feature => ({
                    relation_id: feature.properties.relation_id || "N/A",
                    ownername: feature.properties.ownername || "N/A",
                    pin: feature.properties.pin || "N/A",
                    mobileno: feature.properties.mobileno || "N/A",
                    nooffloor: feature.properties.nooffloor || "N/A",
                    property: feature.properties.property || "N/A",
                    Photo: feature.properties.photolink || "N/A",
                    e_nagarpalikaid: feature.properties.e_nagarpalikaid || "N/A"
                }));

                const uniquePropertyData = Array.from(
                    new Map(propertyData.map(item => [item.relation_id, item])).values()
                );

                // Fetch tax data for each property where e_nagarpalikaid is valid
                const mergedData = await Promise.all(
                    uniquePropertyData.map(async (item) => {
                        if (
                            item.e_nagarpalikaid &&
                            item.e_nagarpalikaid !== "N/A" &&
                            item.e_nagarpalikaid !== "New"
                        ) {
                            const taxData = await fetchTaxData(item.e_nagarpalikaid);
                            return {
                                ...item,
                                ...taxData
                            };
                        }
                        return item; // No tax data merged
                    })
                );

                console.log("Merged Property Data", mergedData);
                setPropertyInfo(mergedData);

                // Highlight features
                const relationIds = data.features.map(f => f.properties.relation_id).filter(Boolean);
                if (relationIds.length > 0) {
                    highlightFeatures(relationIds);
                }
            } else {
                setPropertyInfo([]);
            }
        } catch (error) {
            console.error("Error in fetchPropertyData:", error);
            setPropertyInfo([]);
        }
    };



    const getNewTableData = async (info) => {
        console.log("infoinfo", info)
        // if (!relationIds || !selectedUlb) {
        //     console.log("No relationIds or selectedUlb provided!");
        //     return [];
        // }

        try {
            // const encodedIds = encodeURIComponent(info?.relation_id);
            const encodedIds = encodeURIComponent(`${info?.relation_id}`);
            const encodedUlb = encodeURIComponent(info?.ulbCode); // Encode ULB code

            // Construct Dynamic API URL with selectedUlb
            const apiUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=ulb_cd='${encodedUlb}'%20and%20relation_id+in+(%27${encodedIds}%27)&outFields=*&spatialRel=esriSpatialRelRelation&f=json`;
            console.log("apiUrl", apiUrl)
            // Fetch API Data
            const response = await fetch(apiUrl);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();
            console.log("API Response:", data);

            // Extract features and map them to property data
            const propertyData = data.features?.map(f => ({
                relation_id: f.attributes.relation_id || "N/A",
                ownername: f.attributes.ownername || "N/A",
                pin: f.attributes.pin || "N/A",
                mobileno: f.attributes.mobileno || "N/A",
                nooffloor: f.attributes.nooffloor || "N/A",
                property: f.attributes.property || "N/A",
                Photo: f.attributes.photolink || "N/A"
            })) || [];

            // Remove duplicates based on relation_id
            const uniquePropertyData = Array.from(new Map(propertyData.map(item => [item.relation_id, item])).values());


            setPropertyInfo(uniquePropertyData);
            console.log("Updated Property Info:", uniquePropertyData);

            return uniquePropertyData; // Return updated data if needed
        } catch (error) {
            console.log("Error fetching data:", error);
            setPropertyInfo([]); // Clear state on error
            return [];
        }
    };

    const fetchTaxData = async (propertyId) => {
        console.log("fetchTaxData called with propertyId:", propertyId);

        try {
            const payload = {
                enagarpalika_Id: propertyId,
            };

            console.log("Payload being sent:", payload);

            const response = await GisApiServices.ENPPropertyDetails(payload);

            console.log("Full API response:", response);
            console.log("Response data:", response?.data);

            // Assuming your API sends data inside `response.data.data`
            return response?.data?.data || {};
        } catch (err) {
            console.error("Error in fetchTaxData:", err);

            // If Axios error, print extra info
            if (err.response) {
                console.error("Error response data:", err.response.data);
                console.error("Error response status:", err.response.status);
                console.error("Error response headers:", err.response.headers);
            } else if (err.request) {
                console.error("No response received:", err.request);
            } else {
                console.error("Request setup error:", err.message);
            }

            return {};
        }
    };




    const highlightFeatures = async (relationIds) => {
        try {
            const featureLayer = new FeatureLayer({
                url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/14"
            });

            const query = new Query();
            query.where = `relation_id IN (${relationIds.map(id => `'${id}'`).join(",")})`;
            query.returnGeometry = true;
            query.outFields = ["relation_id"];

            const response = await featureLayer.queryFeatures(query);


            if (response.features.length > 0) {
                const graphics = response.features.map(feature => new Graphic({
                    geometry: feature.geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 255, 0, 0.5], // green with transparency
                        outline: {
                            color: [255, 0, 0],
                            width: 2
                        }
                    }
                }));

                view.graphics.removeAll();
                graphics.forEach(graphic => view.graphics.add(graphic));
                view.goTo(response.features.map(f => f.geometry.extent).reduce((acc, cur) => acc.union(cur)));
            }
        } catch (error) {
            console.log("Error in highlightFeatures:", error);
        }
    };

    const zoomToFeatureOne = async (value, fieldName, layerId) => {
        const layer = new FeatureLayer({
            url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerId}`
        });
        const query = new Query();
        query.where = `${fieldName} = '${value}'`;
        query.returnGeometry = true;
        const response = await layer.queryFeatures(query);
        const geometry = response.features[0].geometry;
        const graphic = new Graphic({
            geometry,
            symbol: {
                type: "simple-fill",
                // color: [0, 255, 255, 0.3],
                color: null,
                outline: {
                    color: [0, 0, 255],
                    width: 2
                }
            }
        });
        view.graphics.removeAll();
        view.graphics.add(graphic);
        view.goTo(graphic.geometry.extent.expand(1.5));
    };

    const zoomToFeatureTow = async (value, fieldName, layerId) => {
        const layer = new FeatureLayer({
            url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerId}`
        });
        const query = new Query();
        query.where = `${fieldName} = '${value}'`;
        query.returnGeometry = true;
        const response = await layer.queryFeatures(query);
        const geometry = response.features[0].geometry;
        const graphic = new Graphic({
            geometry,
            symbol: {
                type: "simple-fill",
                // color: [0, 255, 255, 0.3],
                color: null,
                outline: {
                    color: [0, 0, 255],
                    width: 2
                }
            }
        });
        view.graphics.removeAll();
        view.graphics.add(graphic);
        view.goTo(graphic.geometry.extent.expand(1.5));
    };

    const zoomToFeatureThree = async (value, fieldName, layerId, ulbCode) => {
        try {
            console.log("Params:", value, fieldName, layerId, ulbCode);

            const layer = new FeatureLayer({
                url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerId}`
            });

            const query = new Query();
            query.where = `ulb_cd = '${ulbCode}' AND ${fieldName} = '${value}'`; // Fixed WHERE condition
            query.returnGeometry = true;

            const response = await layer.queryFeatures(query);

            if (response.features.length === 0) {
                console.warn("No features found for the given query");
                return;
            }

            const geometry = response.features[0].geometry;

            const graphic = new Graphic({
                geometry,
                symbol: {
                    type: "simple-fill",
                    color: null, // Transparent fill
                    outline: {
                        color: [0, 0, 255], // Cyan outline
                        width: 2
                    }
                }
            });

            view.graphics.removeAll();
            view.graphics.add(graphic);
            view.goTo(graphic.geometry.extent.expand(1.5));

        } catch (error) {
            console.error("Error in zoomToFeatureThree:", error);
        }
    };


    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };


    // const customStyles = {
    //     control: (base, state) => ({
    //         ...base,
    //         backgroundColor: isTheme === "light" ? "rgb(245, 245, 245)" : "#002864",
    //         color: isTheme === "light" ? "#000" : "#FFFFFF",
    //         fontSize: "12px",
    //         border: isTheme === "light" ? "#000" : "none",
    //         boxShadow: "none",
    //         outline: "none",
    //         opacity: state.isDisabled ? 0.6 : 1,
    //     }),
    //     menu: (provided) => ({
    //         ...provided,
    //         backgroundColor: isTheme === "light" ? "#EBEBEB" : "#FFFFFF",
    //         maxHeight: "300px",
    //         overflowY: "auto",
    //         scrollbarWidth: "none",
    //         msOverflowStyle: "none",
    //         "&::-webkit-scrollbar": { display: "none" }
    //     }),
    //     option: (provided, state) => ({
    //         ...provided,
    //         backgroundColor: state.isSelected
    //             ? isTheme === "light" ? "#1F509A" : "#16386C"
    //             : state.isFocused
    //                 ? isTheme === "light" ? "#1F509A" : "#16386C"
    //                 : isTheme === "light" ? "#EBEBEB" : "#FFFFFF",
    //         color: state.isSelected || state.isFocused ? "#FFFFFF" : "#000", // Ensure text is white when selected or hovered
    //         fontSize: "12px",
    //         padding: "10px",
    //         cursor: "pointer",
    //         "&:hover": {
    //             backgroundColor: isTheme === "light" ? "#1F509A" : "#16386C",
    //             color: "#FFFFFF", // Force white text on hover
    //         },
    //     }),
    //     singleValue: (provided) => ({
    //         ...provided,
    //         color: isTheme === "light" ? "#000" : "#FFFFFF",
    //         fontSize: "12px"
    //     }),
    //     placeholder: (base, state) => ({
    //         ...base,
    //         color: state.isDisabled ? isTheme === "light" ? "#000" : "rgba(255, 255, 255, 0.75)" : isTheme === "light" ? "#000" : "#FFFFFF",
    //         fontSize: "12px"
    //     }),
    //     input: (provided) => ({
    //         ...provided,
    //         color: isTheme === "light" ? "#000" : "#FFFFFF",
    //         fontSize: "12px"
    //     })
    // };

    const fetchOptions = async (query) => {
        const info = {
            ulbCode: ulbCode,
            wardCode: wardCode,
            mobileno: selectedSearch === "Mobile Number" ? searchInput : "",
            ownername: selectedSearch === "Owner Name" ? searchInput : "",
        };

        if (query.length < 3) {
            setOptions([]); // Clear options if less than 3 characters
            return;
        }

        setLoading(true);
        try {

            const urlSearch = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=ulb_cd%3D%27${info?.ulbCode}%27+and+wardno%3D%27${info?.wardCode}%27+and+lower%28ownername%29+like+%27${query}%25%27&outFields=ownername&returnGeometry=false&f=json`
            const response = await fetch(urlSearch);
            const data = await response.json();

            const formattedOptions = data.features.map((item, index) => ({
                value: index, // You can use a unique identifier if available
                label: item.attributes.ownername, // Get the owner name
            }));

            setOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching options:", error);
        }
        setLoading(false);
    };

    // Debounce API Call
    const debouncedFetch = debounce(fetchOptions, 500);

    // Handle Input Change
    const handleInputChange1 = (newValue) => {
        setInputValue(newValue);
        debouncedFetch(newValue);
    };

    useEffect(() => {
        view.graphics.removeAll();
        view.goTo({
            center: [78.746567, 23.83403],
            zoom: 7
        });
    }, [])

    const handleRefresh = () => {
        setUlbs([])
        setSelectedDistrict("")
        setDistrictCode("")
        setUlbCode('')
        setSelectedUlb('')
        setWardCode('')
        setWards([])
        setSearchInput("")
        setSelectedSearch("")
        setWardCode("")
        setPropertyInfo([])
        setSelectedWard("")
        setSelectedSearch('')
        view.graphics.removeAll();
        view.goTo({
            center: [78.746567, 23.83403], // Longitude, Latitude
            zoom: 7 // Adjust zoom level as needed
        });
    }

    const districtOptions = [...districts]
        .sort((a, b) => a.districtName.localeCompare(b.districtName))
        .map(d => ({
            value: d.districtCode,
            label: d.districtName,
        }));


    const ulbOptions = [...ulbs]
        .sort((a, b) => a.ulbName.localeCompare(b.ulbName))
        .map(u => ({
            value: u.ulbCode,
            label: u.ulbName,
        }));

    const wardOptions = [...wards]
        .sort((a, b) => a.wardName.localeCompare(b.wardName))
        .map(w => ({
            value: w.wardCode,
            label: w.wardName,
        }));

    return (
        <div>
            <div className="tooltitlediv linear-gradian-bg mb-2">
                <h6 className="tools-title text-white m-0">Search My Property</h6>
            </div>

            {/* <div className="tabs-container d-flex justify-content-between mt-2 mb-2">
                <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
                <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layer</button>
            </div> */}

            {activeSelect == "layer" ?
                <div className="card shadow-sm p-3 mt-2">
                    <h6 className="fw-bold mb-3">Layers</h6>

                    {/* Search Box */}
                    <div className="mb-3 position-relative">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        {search && (
                            <button
                                className="btn btn-sm btn-link position-absolute end-0 top-0 mt-1 me-1"
                                onClick={() => setSearch("")}
                            >
                                ✕
                            </button>
                        )}
                    </div>

                    {/* Layers List */}
                    <div>
                        {filteredLayers.map((layer) => (
                            <div
                                key={layer}
                                className="d-flex align-items-center justify-content-between py-2 border-bottom"
                            >
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={checked[layer] || false}
                                        onChange={() => toggleCheck(layer)}
                                    />
                                    <span>{layer}</span>
                                </div>
                                <button
                                    className="btn btn-sm p-0 border-0 bg-transparent"
                                    onClick={() => toggleExpand(layer)}
                                >
                                    {expanded[layer] ? <FaChevronUp /> : <FaChevronDown />}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                : <>
                    <div>
                        <label className="lebel-card-text">Select District</label>
                        <Select
                            // options={districts.map((district) => ({
                            //     value: district.districtCode,
                            //     label: district.districtName,
                            // }))}
                            options={districtOptions}
                            value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                            onChange={(selectedOption) => {
                                if (!selectedOption) {
                                    handleRefresh();
                                } else {
                                    handleDistrictChange({ target: { value: selectedOption?.value || "" } });
                                }
                            }}
                            placeholder="Select District"
                            isClearable={true}
                            styles={customStyles}
                            // className="mt-2"
                            isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                        />
                    </div>
                    <div className="mt-2">
                        <label className="lebel-card-text mt-1">Select ULB</label>
                        <Select
                            // options={ulbs.map((ulbs) => ({
                            //     value: ulbs.ulbCode,
                            //     label: ulbs.ulbName,
                            // }))}
                            options={ulbOptions}
                            value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                            onChange={(selectedOption) =>
                                handleUlbChange({ target: { value: selectedOption?.value || "" } })
                            }
                            placeholder={"Select ULB"}
                            isClearable={true}
                            isDisabled={!districtCode || authData?.UserType === "User"}
                            styles={customStyles}
                        // className="mt-2"
                        />
                    </div>
                    <div className="mt-2">
                        <label className="lebel-card-text mt-1">Select Ward</label>
                        <Select
                            options={wards
                                .slice()
                                .sort((a, b) => a.wardCode - b.wardCode)
                                .map((ward) => ({
                                    value: ward.wardCode,
                                    label: `${ward.wardCode} - ${ward.wardName}`,
                                }))
                            }
                            value={
                                wardCode
                                    ? {
                                        value: wardCode,
                                        label: `WardNo.${wardCode} - ${selectedWard}`,
                                    }
                                    : null
                            }
                            onChange={(selectedOption) =>
                                handleWardChange({ target: { value: selectedOption?.value || "" } })
                            }
                            placeholder="Select ward"
                            isClearable={true}
                            styles={customStyles}
                            isDisabled={!ulbCode}
                            // className="mt-2"
                        />
                    </div>
                    <div>
                        <label className="lebel-card-text mt-2 mb-2">Select Search Type</label>
                        <Select
                            options={searchOptions.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                            value={selectedSearch ? { value: selectedSearch, label: selectedSearch } : null}
                            onChange={(selectedOption) =>
                                handleSearchChange({ target: { value: selectedOption?.value || "" } })
                            }
                            placeholder="Search Type"
                            isClearable={true}
                            styles={customStyles}
                            isDisabled={!wardCode}
                            className="mt-2"
                        />
                        {selectedSearch && (
                            <div>
                                {selectedSearch === "Owner Name" ?
                                    <Select
                                        options={options}
                                        onInputChange={handleInputChange1}
                                        onChange={(selectedOption) => setSearchInput(selectedOption?.label)}
                                        placeholder="Search name"
                                        isClearable={true}
                                        isLoading={loading}
                                        className="mt-2"
                                        styles={customStyles}
                                    />
                                    :
                                    <input
                                        type="text"
                                        value={searchInput}
                                        onChange={handleInputChange}
                                        placeholder={`Enter ${selectedSearch}`}
                                        className="form-control buffer-form-control mt-2"
                                        style={{
                                            backgroundColor: isTheme === 'light' ? '#F5F5F5' : '#002864',
                                            color: isTheme === 'light' ? '#000000' : 'white',
                                        }}
                                    />
                                }
                                <div className='buffer-btndiv'>
                                    <button
                                        className={!searchInput ? "btn-comman btn-runtax comman-text" : "btn-adddestination"}
                                        onClick={handleGetInfo}
                                        style={{
                                            marginTop: "10px",
                                            background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                                            // backgroundColor: isTheme === 'light' && "#1F509A",
                                            color: isTheme === 'light' && searchInput && "#FFF"
                                        }}
                                        disabled={!searchInput}
                                    >
                                        Get Info
                                    </button>

                                </div>
                            </div>
                        )}

                        <button
                            className="btn-refresh2"
                            onClick={handleRefresh}
                            style={{ marginTop: "10px" }}
                        >
                            {isTheme === 'light' ?
                                <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
                                :
                                <img src="img/refresh.svg" alt="refresh" />
                            }
                            Refresh
                        </button>
                        {propertyInfo.length > 0 ? (
                            <div className="mt-2">
                                <h5 className="tools-title m-0 p-0">Property</h5>
                                <div className="row scroll-hidden"
                                    style={{
                                        maxHeight: '82vh',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {propertyInfo.map((item, index) => {
                                        return (
                                            <div key={index} className="col-12 mb-3">
                                                <div
                                                    className="mis-card h-100"
                                                    style={{
                                                        backgroundColor: isTheme === 'light' ? 'rgb(245, 245, 245)' : '#1E4580'
                                                    }}
                                                >
                                                    <div className={`d-flex flex-column justify-content-center ${isTheme === 'light' ? '' : 'mis-propertycard'}`}>
                                                        <p className="propertyinfodiv d-flex justify-content-between">
                                                            <span>Serial Number</span> {index + 1}
                                                        </p>
                                                        <p className="propertyinfodiv d-flex justify-content-between">
                                                            <span>Owner</span> {item.ownername}
                                                        </p>
                                                        <p className="propertyinfodiv d-flex justify-content-between">
                                                            <span>Mobile</span> {item.mobileno}
                                                        </p>
                                                        <p className="propertyinfodiv d-flex justify-content-between">
                                                            <span>Property ID</span> {item.e_nagarpalikaid}
                                                        </p>
                                                        {item.arrear !== undefined && item.arrear !== null && (
                                                            <p className="propertyinfodiv d-flex justify-content-between">
                                                                <span>Arrear</span> {item.arrear}
                                                            </p>
                                                        )}
                                                        {item.current_year_tax !== undefined && item.current_year_tax !== null && (
                                                            <p className="propertyinfodiv d-flex justify-content-between">
                                                                <span>Current year tax</span> {item.current_year_tax}
                                                            </p>
                                                        )}
                                                        {item.total !== undefined && item.total !== null && (
                                                            <p className="propertyinfodiv d-flex justify-content-between">
                                                                <span>Total</span> {item.total}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        ) : (
                            selectedSearch && searchInput && <p>No data found.</p>
                        )}

                    </div>
                </>}
        </div>
    );
};

export default RouteTools;